export class CallingCodeVM {
  commonName?: string;
  name?: string;
  callingCode?: number;
  flag?: string;
}
